/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { CreatePromoCode200ResponseData } from './CreatePromoCode200ResponseData'
import {
  CreatePromoCode200ResponseDataFromJSON,
  CreatePromoCode200ResponseDataFromJSONTyped,
  CreatePromoCode200ResponseDataToJSON,
} from './CreatePromoCode200ResponseData'

/**
 *
 * @export
 * @interface CreatePromoCode200Response
 */
export interface CreatePromoCode200Response {
  /**
   *
   * @type {boolean}
   * @memberof CreatePromoCode200Response
   */
  status: boolean
  /**
   *
   * @type {CreatePromoCode200ResponseData}
   * @memberof CreatePromoCode200Response
   */
  data: CreatePromoCode200ResponseData
}

/**
 * Check if a given object implements the CreatePromoCode200Response interface.
 */
export function instanceOfCreatePromoCode200Response(
  value: object
): value is CreatePromoCode200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function CreatePromoCode200ResponseFromJSON(
  json: any
): CreatePromoCode200Response {
  return CreatePromoCode200ResponseFromJSONTyped(json, false)
}

export function CreatePromoCode200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreatePromoCode200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: CreatePromoCode200ResponseDataFromJSON(json['data']),
  }
}

export function CreatePromoCode200ResponseToJSON(
  value?: CreatePromoCode200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: CreatePromoCode200ResponseDataToJSON(value['data']),
  }
}
